import React, { useState, Fragment } from 'react'
import { Text, Box } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'
import { Transition } from 'react-transition-group'

import {
  TabsStyled,
  TabsInnerStyled,
  TabsNavigationStyled,
  TabsNavigationItemStyled,
  TabsNavigationItemIconStyled,
  TabsContentStyled,
  TabsContentContainerStyled,
  TabsContentItemStyled,
  TabsNavigationItemContentStyled,
  TabsNavigationContainerStyled,
  TabsNavigationSearchStyled
} from './styles'
import { ProductTableTabsProps } from './types'
import Table from '../../Table'
import TableSearchForm from '../../../molecules/TableSearchForm'
import StaticImage from '../../../atoms/ImageStatic'
import ProductInfo from './../../../organisms/ProductInfo'
import Slider from '../../Sliders'
import { filterObject } from '../../../../common/helpers'
import { transitionStyles } from '../cfg'
import { TABLE_TABS_SLIDER_CFG as config } from '../../Sliders/config'

const ProductTableTabs: React.FC<ProductTableTabsProps> = ({ data }) => {
  const { list, withSearch, withPagination } = data

  const isDesktop = useResponsiveValue([false, false, true, true], {
    defaultIndex: 0
  })
  const initValue = list[0].title

  // States
  const [isActive, setIsActive] = useState(initValue)
  const [inputVal, setInputVal] = useState('')

  // Filtering
  let selectedTabArray = list[0]
  let selectedTabItemArray = selectedTabArray.item.table
  const [filteredData, setFilteredData] = useState(selectedTabItemArray)

  // Search handler
  const handleOnChangeSearch = (e: any) => {
    let value = e.target.value.toLowerCase()
    let result = []

    // set input val
    setInputVal(value)

    if (isDesktop) {
      selectedTabArray = list.filter((el) => el.title === isActive)
      selectedTabItemArray = selectedTabArray[0].item.table
      result = filterObject(selectedTabItemArray, value)

      // set new filtered data
      setFilteredData(result)
    }
  }
  const handleOnSubmitSearch = (e: any) => {
    e.preventDefault()
    let result = []

    selectedTabArray = list.filter((el) => el.title === isActive)
    selectedTabItemArray = selectedTabArray[0].item.table
    result = filterObject(selectedTabItemArray, inputVal)

    // set new filtered data
    setFilteredData(result)

    // set input val
    setInputVal(inputVal)
  }

  // Accordion handler
  const handleClick = (value: string): void => {
    setIsActive(value)
    selectedTabArray = list.filter((el) => el.title === value)
    selectedTabItemArray = selectedTabArray[0].item.table

    // clear search input val
    setInputVal('')

    // set new filtered data
    setFilteredData(selectedTabItemArray)
  }

  const tabsNavigationTemplate = list.map(({ tabKey, tabIcon, title }) => {
    const isTabActive = isActive === title
    return (
      <TabsNavigationItemStyled
        key={tabKey}
        onClick={() => handleClick(title)}
        isActive={isTabActive}
        aria-hidden={!isTabActive}
        type="button"
      >
        <TabsNavigationItemContentStyled>
          {tabIcon && (
            <TabsNavigationItemIconStyled>
              <StaticImage image={tabIcon} />
            </TabsNavigationItemIconStyled>
          )}
          <Text
            as="p"
            sx={{
              variant: 'bodyRaleway7',
              fontFamily: 'secondary'
            }}
          >
            {title}
          </Text>
        </TabsNavigationItemContentStyled>
      </TabsNavigationItemStyled>
    )
  })

  return (
    <TabsStyled>
      <TabsInnerStyled>
        <TabsNavigationContainerStyled as="div">
          <TabsNavigationStyled as="div">
            {isDesktop ? <Slider {...{ config }}>{tabsNavigationTemplate}</Slider> : <Fragment>{tabsNavigationTemplate}</Fragment>}
          </TabsNavigationStyled>
        </TabsNavigationContainerStyled>
        <TabsContentStyled as="div" variant="inners.primary">
          {list.map(({ tabKey, title, item }) => {
            const isTabActive = isActive === title
            return (
              <TabsContentContainerStyled key={`${tabKey}-tab`} isActive={isTabActive} aria-hidden={!isTabActive}>
                <Transition in={isTabActive} timeout={150} appear>
                  {(state) => (
                    <TabsContentItemStyled
                      style={{
                        ...transitionStyles[state]
                      }}
                    >
                      <Box
                        sx={{
                          marginBottom: ['60px', '', '80px']
                        }}
                      >
                        <ProductInfo data={item.product} />
                      </Box>
                      {item.table.length > 0 && (
                        <>
                          <Box>
                            {withSearch && (
                              <TabsNavigationSearchStyled>
                                <TableSearchForm
                                  placeholder="Search e.g. cadchf"
                                  value={inputVal}
                                  onChange={(e) => handleOnChangeSearch(e)}
                                  onSubmit={(e) => handleOnSubmitSearch(e)}
                                />
                              </TabsNavigationSearchStyled>
                            )}
                          </Box>
                          <Box>
                            <Table id={tabKey} data={item.table} {...{ filteredData, withPagination, withSearch }} />
                          </Box>
                        </>
                      )}
                    </TabsContentItemStyled>
                  )}
                </Transition>
              </TabsContentContainerStyled>
            )
          })}
        </TabsContentStyled>
      </TabsInnerStyled>
    </TabsStyled>
  )
}

export default ProductTableTabs
